export default "__VITE_ASSET__Hpqj2z97__"